export const FORM_ID = "lead-form";

const getForms = () => Array.from(document.querySelectorAll(`#${FORM_ID}`));

const getNameInput = (formEl) =>
  formEl ? formEl.querySelector('input[name="customer_name"]') : null;

export const focusNameField = (formEl) => {
  const nameInput = getNameInput(formEl);
  if (!nameInput) return;

  try {
    nameInput.focus({ preventScroll: true });
  } catch (err) {
    nameInput.focus();
  }
};

export const findNearestForm = (anchorEl) => {
  const forms = getForms();
  if (forms.length === 0) return null;
  if (!anchorEl) return forms[0];

  const anchorTop = anchorEl.getBoundingClientRect().top + window.scrollY;

  const below = forms.find(
    (f) => f.getBoundingClientRect().top + window.scrollY >= anchorTop - 8,
  );
  return below || forms[forms.length - 1];
};

export const scrollToFormAndFocusName = (e, anchorEl) => {
  if (e && typeof e.preventDefault === "function") e.preventDefault();

  const origin = anchorEl || (e && e.currentTarget) || null;
  const formEl = findNearestForm(origin);
  if (!formEl) return;

  formEl.scrollIntoView({ behavior: "smooth", block: "start" });
  setTimeout(() => focusNameField(formEl), 400);
};

export const scrollToNearestFormAndFocusName = () => {
  const forms = getForms();
  if (forms.length === 0) return;

  const viewportTop = window.scrollY;
  const viewportBottom = window.scrollY + window.innerHeight;

  const onScreen = forms.find((f) => {
    const top = f.getBoundingClientRect().top + window.scrollY;
    const bottom = f.getBoundingClientRect().bottom + window.scrollY;
    return bottom > viewportTop && top < viewportBottom;
  });

  const below = forms.find(
    (f) => f.getBoundingClientRect().top + window.scrollY >= viewportTop,
  );

  const formEl = below || forms[forms.length - 1];
  if (!formEl) return;

  formEl.scrollIntoView({ behavior: "smooth", block: "start" });
  setTimeout(() => focusNameField(formEl), 400);

  return onScreen ? onScreen : formEl;
};

export const scrollToHeroFormAndFocusName = () => {
  const formEl = getForms()[0];
  if (!formEl) return;

  formEl.scrollIntoView({ behavior: "smooth", block: "start" });
  setTimeout(() => focusNameField(formEl), 400);
};

export default scrollToFormAndFocusName;
